<template>
    <button
        :type="type ?? 'button'"
        :disabled="disabled"
        :class="[
            'inline-flex items-center justify-center font-medium rounded transition-colors',
            'focus:outline-none focus:ring-2 focus:ring-primary/50',
            'disabled:opacity-40 disabled:cursor-not-allowed',
            block ? 'w-full' : '',
            large ? 'px-5 py-3 text-base min-h-[48px]' : 'px-4 py-2 text-sm min-h-[40px]',
            (variant ?? 'primary') === 'primary' ? 'bg-primary text-primary-fg hover:brightness-110' : '',
            variant === 'success' ? 'bg-success text-white hover:brightness-110' : '',
            variant === 'danger' ? 'bg-danger text-white hover:brightness-110' : '',
            variant === 'flat' ? 'bg-transparent text-white hover:bg-white/10' : '',
            variant === 'purple' ? 'bg-purple-600 text-white hover:brightness-110' : '',
            variant === 'cyan' ? 'bg-sky-500 text-white hover:brightness-110' : '',
            variant === 'gray' ? 'bg-gray-500 text-white hover:brightness-110' : '',
            variant === 'teal' ? 'bg-teal-500 text-white hover:brightness-110' : ''
        ]"
    >
        <slot />
    </button>
</template>

<script setup lang="ts">
    defineProps<{
        variant?: 'primary' | 'success' | 'danger' | 'flat' | 'purple' | 'cyan' | 'gray' | 'teal'
        block?: boolean
        large?: boolean
        disabled?: boolean
        type?: 'button' | 'submit'
    }>()
</script>
